import { SolidViewLayoutManager } from "@solidstarters/solid-core-ui";
import axios from "axios";
import { getSession } from "next-auth/react";

let vesselOption: Record<string, any> = {}; 
const voyageMasterHandler = async (event: any) => {
    const { modifiedField, modifiedFieldValue, viewMetadata, } = event;
    vesselOption[modifiedField] = modifiedFieldValue?.value;
    
    const layout = viewMetadata.layout;
    const layoutManager = new SolidViewLayoutManager(layout);
    const newFormData: any = {};
    if (vesselOption?.location) {
        const session: any = await fetchUser();
        const API_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL; 
        const token = session?.user?.accessToken || "";
        const fetchLocationData = async () => {
            try {
                const filters = {
                    name: { $eq: vesselOption?.location},
                };
                const params = new URLSearchParams();
                Object.entries(filters).forEach(([key, value]) => {
                    if (value && value.$eq) {
                        params.append(`filters[${key}][$eq]`, value.$eq);
                    }
                });
                const response = await axios.get(`${API_URL}/api/location-master`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    params
                });
                return response.data;
            } catch (error:any) {
                console.error("Error fetching location data:", error.response?.data || error.message);
                return null;
            }
        };
    
        const locationData = await fetchLocationData();
        const locationRecord = locationData?.data?.records || [];
        const locationId = locationRecord.length > 0 ? locationRecord[0].id : null;
        const whereClause = `&filters[location][$eq]=${locationId}`;
        // layoutManager.updateNodeAttributes('terminal', { "whereClause": whereClause});

        layoutManager.updateNodeAttributes('terminal', {
            whereClause: `&filters[location][$eq]=${locationId}`,
          } as any); 
    }
    return {
        layoutChanged: true,
        dataChanged: true,
        newLayout: layoutManager.getLayout(), 
        newFormData: newFormData
    }
}
const fetchUser = async () => {
    let session: any = await getSession();
    return session;
}

export default voyageMasterHandler;